import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

export default function MissoulaPage() {
  return (
    <>
      <CitySEOHead
        city="Missoula"
        state="Montana"
        stateAbbr="MT"
        route="/cities/missoula"
        title="Emergency Passport Missoula, MT — Expedited & Fast Passport Service | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Missoula, Montana. Serving Missoula County, Lolo, Hamilton, and surrounding areas. As fast as 24 hours — no agency trip needed."
        geoPlacename="Missoula, Montana"
        geoPosition="46.8721;-113.9940"
        faqs={[
          { q: "How do I get an expedited passport in Missoula, Montana?", a: "Missoula residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agencies are in Seattle (400 miles west) or Denver (500 miles southeast)." },
          { q: "Where is the nearest passport agency to Missoula?", a: "The Seattle Regional Passport Agency (915 2nd Ave, Seattle, WA) is approximately 400 miles west. The Denver agency is 500+ miles southeast. Fast Passport Center eliminates both those trips." },
        ]}
        servicesSchema={[]}
        statePageName="Montana"
        statePageRoute="/states/montana"
      />
      <div className="min-h-screen bg-white">
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <LocalAreaSection />
      <ServicesSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <FinalCTA />
    </div>
    </>
  );
}